import React from "react";
import PropTypes from "prop-types";

export const SolidArrow = ({ color = "#333" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <mask
        id="mask0_7938_993"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect y="18" width="18" height="18" transform="rotate(-90 0 18)" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7938_993)">
        <path
          d="M12.4282 6.00001C13.2173 6.00001 13.6955 6.87116 13.2719 7.53689L9.84354 12.9243C9.45059 13.5418 8.54917 13.5418 8.15622 12.9243L4.72789 7.53689C4.30425 6.87116 4.78246 6.00001 5.57155 6.00001L12.4282 6.00001Z"
          fill="black"
        />
      </g>
    </svg>
  );
};

SolidArrow.propTypes = {
  color: PropTypes.string,
};
